import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "timeSelects"]

  connect() {
    this.toggleTimeSelects()
  }

  toggleTimeSelects() {
    const isOpen = this.statusTarget.value === "open"
    const hasTimeValues = this.hasTimeValues()
    
    // Show time selects if status is "open" OR if there are existing time values
    const shouldShow = isOpen || hasTimeValues
    
    this.timeSelectsTarget.classList.toggle("hidden", !shouldShow)
    
    // If there are time values but status isn't "open", set status to "open"
    if (hasTimeValues && !isOpen) {
      this.statusTarget.value = "open"
    }
  }

  hasTimeValues() {
    const timeSelects = this.timeSelectsTarget.querySelectorAll('select[data-time-select-target]')
    return Array.from(timeSelects).some(select => select.value && select.value !== '')
  }

  statusChanged() {
    this.toggleTimeSelects()
  }
} 